const sortByFullName = (rowA, rowB, id) => {
  const first = rowA?.original?.[id]?.fullName?.toLocaleLowerCase() || '';
  const second = rowB?.original?.[id]?.fullName?.toLocaleLowerCase() || '';
  return first?.localeCompare(second);
};

export default sortByFullName;
